/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Credits_QInputs */

const en_road_dude_faq_credits_q = /** @type {(inputs: Road_Dude_Faq_Credits_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I watch the examples and copy the prompts for free?`)
};

const zh_road_dude_faq_credits_q = /** @type {(inputs: Road_Dude_Faq_Credits_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看案例、复制提示词需要积分吗？`)
};

/**
* | output |
* | --- |
* | "Can I watch the examples and copy the prompts for free?" |
*
* @param {Road_Dude_Faq_Credits_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_credits_q = /** @type {((inputs?: Road_Dude_Faq_Credits_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Credits_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_credits_q(inputs)
	return zh_road_dude_faq_credits_q(inputs)
});
export { road_dude_faq_credits_q as "road_dude.faq.credits.q" }